import { render, staticRenderFns } from "./TrisChecklist.vue?vue&type=template&id=8a48e0f4&scoped=true"
import script from "./TrisChecklist.vue?vue&type=script&lang=ts"
export * from "./TrisChecklist.vue?vue&type=script&lang=ts"
import style0 from "@/styles/_pdf.scss?vue&type=style&index=0&id=8a48e0f4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a48e0f4",
  null
  
)

export default component.exports